// extracted by mini-css-extract-plugin
export default {"text-input":"X5e814q","text-input__element":"gLCvMl9","text-input__label":"kQofC6e","text-input__icon":"m0efRpi","text-input__input-message":"dTlPOwg","text-input--error":"_42C70Y"};